// extracted by mini-css-extract-plugin
export default {"clickable":"effects_clickable__6a7u4"};